export default __webpack_public_path__ + "static/media/slide-3.8b661449.jpg";